export const MAIN_WRAPPER_CLASSNAME = 'categories-menu-wrapper';
export const SHOWN_CLASSNAME = 'shown';
